import { render, staticRenderFns } from "./GoogleCampaigns.vue?vue&type=template&id=2537c134&scoped=true&"
import script from "./GoogleCampaigns.vue?vue&type=script&lang=js&"
export * from "./GoogleCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./GoogleCampaigns.vue?vue&type=style&index=0&id=2537c134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2537c134",
  null
  
)

export default component.exports